import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/**
 * @deprecated Delete this folder when cleaning up mbw-43-allow-status-mapping-on-business-board
 */
export const boardConfettiEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-business-board-confetti" */
				'./main'
			),
	),
	getPreloadProps: () => ({}),
});
